import odata from "@/core/api/mixin/odata";
import rest from "@/core/api/mixin/rest";
import { apiClient } from "@/core/api/httpClient";

export default {
  ...odata("organizations"),
  ...rest("organizations"),
  getBilling: async (id) => {
    return await apiClient.get(`billing-info?organization_id=${id}`);
  },
  getUserOrgItems: async (id) => {
    return await apiClient.get(`organizations/current-user`);
  },
};
